// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__33Spu","messages":"Chat_messages__3KYSj","dateDivider":"Chat_dateDivider__Z995m"};